import React from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

// Texture background image (you can replace the URL with your local asset or a similar pattern)
const BG_TEXTURE = "url('https://www.transparenttextures.com/patterns/cubes.png')"; // Example texture, or use a local one if you prefer.
// For "ultra stylish", let's use a nice gradient + texture overlay.

const LoadingOverlay = () => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      zIndex="99999"
      bg="gray.900" // Fallback color
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
        {/* Background Gradient & Texture */}
        <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bgGradient="linear(to-br, gray.900, blue.900)"
            opacity="1"
        />
        
        {/* Animated overlay circle for style */}
        <Box 
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            width="600px"
            height="600px"
            bg="blue.500"
            borderRadius="full"
            filter="blur(150px)"
            opacity="0.1"
        />

        {/* Content */}
        <VStack spacing={6} zIndex="10">
            <Spinner 
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.700'
                color='blue.400'
                size='xl'
                w="80px"
                h="80px"
            />
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
            >
                <Text 
                    color="white" 
                    fontSize="xl" 
                    fontWeight="medium" 
                    letterSpacing="wider"
                    textTransform="uppercase"
                >
                    Chargement
                </Text>
            </motion.div>
        </VStack>
    </Box>
  );
};

export default LoadingOverlay;
